import { Component, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-recruiter-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './recruiter-navbar.component.html',
  styleUrls: ['./recruiter-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterNavbarComponent {
  isScrolled = false;
  bannerVisible = true;
  isMobileMenuOpen = false;
  scrollProgress = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 20;
    
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    
    if (windowHeight > 0) {
      this.scrollProgress = Math.min(100, Math.max(0, (scrollPosition / windowHeight) * 100));
    } else {
      this.scrollProgress = 0;
    }
  }

  dismissBanner() {
    this.bannerVisible = false;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  scrollTo(selector: string) {
    const element = document.querySelector(selector);
    if (element) {
      // Get the fixed header height approximately (e.g. 80px)
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    
    // Close mobile menu if open
    if (this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
    }
  }
}
